import React from 'react';
import styled from 'styled-components';

const StyledButton = styled.button`
  width: ${({ contain }) => (contain ? 'auto' : '100%')};
  min-height: 3.15rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: .5rem;
  padding: 0.72rem 1.25rem;
  border: 1px solid ${({ color }) => (color === 'red' ? 'transparent' : '#000')};
  border-radius: 999px;
  color: #fff;
  background: ${({ color }) => (color === 'red' ? 'var(--color-errorRed)' : '#000')};
  font-weight: 800;
  cursor: pointer;
  box-shadow: 0 0.65rem 1.5rem rgba(0, 0, 0, 0.14);
  transition: transform 160ms ease, background 160ms ease, box-shadow 160ms ease;

  &:hover:not(:disabled) {
    transform: translateY(-2px);
    background: ${({ color }) => (color === 'red' ? '#a92d2d' : '#171717')};
    box-shadow: 0 0.9rem 1.8rem rgba(0, 0, 0, 0.2);
  }

  &:active:not(:disabled) {
    transform: translateY(0);
  }

  &:disabled {
    color: #777;
    border-color: #e4e1dc;
    background: #eceae6;
    cursor: not-allowed;
    box-shadow: none;
  }
`;

const Button = ({ children, disabled, loading, contain, onClick, color, ...rest }) => (
  <StyledButton
    color={color}
    contain={contain}
    disabled={disabled || Boolean(loading)}
    onClick={onClick}
    aria-busy={Boolean(loading)}
    {...rest}
  >
    {loading || children}
  </StyledButton>
);

export default Button;
